import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onApplyListFiltersEvent,
  removeApplyListFiltersEvent,
} from '@shared/event/events/list-filter'

const initListFiltersEvents = (Analytics: GooglePlugin) => {
  const applyListFiltersToken = onApplyListFiltersEvent(({ listFilters }) => {
    for (const [key, value] of Object.entries(listFilters)) {
      if (value && value.length) {
        Analytics.event({
          event: `item_list_filter_${key.split('.').at(-1) || key}`,
          item_list_filter_selection:
            typeof value === 'string' ? value : value.toString(),
        })
      }
    }
  })

  return () => {
    removeApplyListFiltersEvent(applyListFiltersToken)
  }
}

export default initListFiltersEvents
